import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import {
    GenerateYandexPayWidgetURLMethod,
    type GenerateYandexPayWidgetURLPathParameters,
    type GenerateYandexPayWidgetURLResponseSuccess,
    type GenerateYandexPayWidgetURLSearchParams,
    getGenerateYandexPayWidgetURLUrl,
    getGetPaymentContextUrl,
    GetPaymentContextMethod,
    type GetPaymentContextPathParameters,
    type GetPaymentContextResponseSuccess,
    type GetPaymentContextSearchParams,
} from '@/shared/api/openApi';
import { request } from '@/shared/api/request';

const paymentApi = createApi({
    name: 'entities/order/api/paymentApi',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            GeneratePayboxPayURL: builder.query<
                GenerateYandexPayWidgetURLResponseSuccess,
                GenerateYandexPayWidgetURLSearchParams & GenerateYandexPayWidgetURLPathParameters
            >({
                query: ({ order_id, store_slug, ...payload }) => {
                    return {
                        url: getGenerateYandexPayWidgetURLUrl({ order_id, store_slug }),
                        method: GenerateYandexPayWidgetURLMethod,
                        params: payload satisfies GenerateYandexPayWidgetURLSearchParams,
                    };
                },
                keepUnusedDataFor: 0,
            }),

            GetPaymentContext: builder.query<
                Required<GetPaymentContextResponseSuccess>,
                GetPaymentContextSearchParams & GetPaymentContextPathParameters
            >({
                query: ({ order_id, store_slug, ...payload }) => {
                    return {
                        url: getGetPaymentContextUrl({ order_id, store_slug }),
                        method: GetPaymentContextMethod,
                        params: payload satisfies GetPaymentContextSearchParams,
                    };
                },
                keepUnusedDataFor: 0,
            }),
        };
    },
});

export const getOrderPayboxPayURL = (
    params: GenerateYandexPayWidgetURLSearchParams & GenerateYandexPayWidgetURLPathParameters
) => paymentApi.endpoints.GeneratePayboxPayURL.query(params);

export const getPaymentContext = paymentApi.endpoints.GetPaymentContext.query;
